<template lang="html">
  <div :is="tag" class="dropdown">
    <v-button
      class="dropdown-toggle"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <slot></slot>
    </v-button>
    <div
      class="dropdown-menu"
      :class="right ? 'dropdown-menu-right' : ''"
      :style="'max-height: ' + maxheight"
    >
      <slot name="menu"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    right: Boolean,
    tag: {
      default: 'div',
    },
    maxheight: {
      default: 'none',
    },
  },
  // mounted: function() {
  //   this.$nextTick(function() {
  //     window.addEventListener('click', function(e){
  //       if (document.getElementsByClassName('dropdown')[0].contains(e.target)){
  //         console.log('dentro');
  //       } else{
  //         // Clicked outside the box
  //         console.log('fora');
  //       }
  //     });
  //   })
  // }
};
</script>

<style lang="scss">
.dropdown {
  .dropdown-menu {
    border-radius: 0;
    margin-top: 0;
    max-width: 320px;
    overflow-y: auto;
    overflow-x: hidden;
    // .button {
    //   color: #000;
    //   width: 100%;
    //   border-radius: 0;
    // }
    // .button-inner {
    //   display: flex;
    //   justify-content: start;
    //
    //   .badge {
    //     margin-left: auto;
    //     background: black(.1);
    //     font-size: 12px;
    //     line-height: 1em;
    //     text-align: center;
    //     padding: 4px;
    //     min-width: 20px;
    //     height: 20px;
    //     border-radius: 10px;
    //   }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/dropdown.vue